const MULTIPLIER = 1e5;
/**
 * Rounds the number to match the video.currentTime (5 decimels after zero)
 * @param time the Float of the current time
 */
export default function normalizeCurrentTime(currentTime: number): number {
    return Math.ceil(currentTime * MULTIPLIER) / MULTIPLIER;
}
